import {
  GeneralCargoInventoryDto,
  GeneralCargoItemPlanningDto,
  GeneralCargoOrderDto,
  GeneralCargoOrderLocationDto,
  GeneralCargoOrdersApi,
  GeneralCargoOutboundValidationResultDto,
  GeneralCargoStockDto,
  GeneralCargoStockOccupanciesApi,
  GeneralCargoStocksApi,
  GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest,
  GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest,
  UpdateGeneralCargoOrderPlanningDto,
  UpdateGeneralCargoStockOccupancyDto,
} from '@storage/app/api'
export class GeneralCargoStockService {
  constructor(
    private api: GeneralCargoStocksApi,
    private occupancyApi: GeneralCargoStockOccupanciesApi,
    private readonly _generalCargoOrdersApi: GeneralCargoOrdersApi,
  ) {}

  async getAll(): Promise<Array<GeneralCargoStockDto>> {
    const { data: GeneralCargoStocks } = await this.api.generalCargoStocksGetAll()
    return GeneralCargoStocks
  }

  async getPlannedOccupanciesByOrderIds(
    orderIds: number[],
  ): Promise<Array<{ orderId: number; planned: GeneralCargoItemPlanningDto[] }>> {
    if (!orderIds.length) {
      return []
    }
    const { data } = await this.occupancyApi.generalCargoStockOccupanciesGetOrderPlanningByOrderIds({ orderIds })
    return data
  }

  //TODO: separate occupancy/planning from stock
  async getPlannedOccupanciesByOrderId(
    orderId: number,
    cargoItemId?: number,
  ): Promise<Array<GeneralCargoItemPlanningDto>> {
    const { data: plannedOccupancies } = await this.occupancyApi.generalCargoStockOccupanciesGetOrderPlanning({
      orderId,
      cargoItemId,
    })
    return plannedOccupancies
  }

  async getByQuery(
    params: GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest,
  ): Promise<Array<GeneralCargoStockDto>> {
    const { data: GeneralCargoStocks } = await this.api.generalCargoStocksGetByQueryParams(params)
    return GeneralCargoStocks
  }

  async getByOrderId(orderId: number, cargoItemId?: number): Promise<GeneralCargoStockDto> {
    const { data: GeneralCargoStock } = await this.api.generalCargoStocksGetByOrderId({
      orderId,
      cargoItemId,
    })
    return GeneralCargoStock
  }

  async getGeneralCargoOrderById(orderId: number): Promise<GeneralCargoOrderDto> {
    const { data: generalCargoOrder } = await this._generalCargoOrdersApi.generalCargoOrdersGetByOrderId({
      orderId,
    })
    return generalCargoOrder
  }

  async getInventory(
    params: GeneralCargoStocksApiGeneralCargoStocksGetByQueryParamsRequest,
  ): Promise<Array<GeneralCargoInventoryDto>> {
    const { data: GeneralCargoInventory } = await this.api.generalCargoStocksGetInventory(params)
    return GeneralCargoInventory
  }

  async getOrderLocations(orderIds: number[]): Promise<Array<GeneralCargoOrderLocationDto>> {
    if (!orderIds.length) {
      return []
    }
    const { data } = await this.api.generalCargoStocksGetOrderLocations({ orderIds })
    return data
  }

  async updateOccupancy(
    dto: UpdateGeneralCargoStockOccupancyDto,
    inbound: boolean,
  ): Promise<GeneralCargoStockDto> {
    const { data: GeneralCargoStock } = inbound
      ? await this.occupancyApi.generalCargoStockOccupanciesPutToStock({
          updateGeneralCargoStockOccupancyDto: dto,
        })
      : await this.occupancyApi.generalCargoStockOccupanciesTakeFromStock({
          updateGeneralCargoStockOccupancyDto: dto,
        })

    return GeneralCargoStock
  }

  async planDropOff(
    dto: UpdateGeneralCargoOrderPlanningDto,
  ): Promise<GeneralCargoItemPlanningDto[]> {
    const { data: orderInboundPlanning } = await this.occupancyApi.generalCargoStockOccupanciesPlanOrder({
      updateGeneralCargoOrderPlanningDto: dto,
    })
    return orderInboundPlanning
  }

  async uploadDamageFile(file: File): Promise<string> {
    const resp = await this.occupancyApi.generalCargoStockOccupanciesUploadDamageFile({ file: file })
    return resp.data
  }

  async validateOutboundRequest(
    params: GeneralCargoStocksApiGeneralCargoStocksValidateOutboundOrderRequest,
  ): Promise<GeneralCargoOutboundValidationResultDto> {
    const { data: validationResult } = await this.api.generalCargoStocksValidateOutboundOrder(params)

    return validationResult
  }
}
